import { type AnyAction, type ThunkAction } from '@reduxjs/toolkit'
import posthog from 'posthog-js'

import { pushFeedbackNotification } from '../../store/notifications/actions'
import { selectNotifications } from '../../store/notifications/selectors'
import { type RootState } from '../../store/store'
import { hasBeenAsked } from './feedbackPromptStorage'

export const FEEDBACK_PROMPT_EVENTS = {
  shown: 'feedback_prompt_shown',
  routeChosen: 'feedback_prompt_route_chosen',
  dismissed: 'feedback_prompt_dismissed',
} as const

const FEEDBACK_PROMPT_DELAY_MS = 20000

export const requestFeedbackPrompt =
  (): ThunkAction<void, RootState, unknown, AnyAction> =>
  (dispatch, getState): void => {
    const alreadyQueued = selectNotifications(getState()).some(({ type }) => type === 'FEEDBACK')

    if (hasBeenAsked() || alreadyQueued) {
      return
    }

    dispatch(pushFeedbackNotification({ extra: { delay: FEEDBACK_PROMPT_DELAY_MS } }))
    posthog.capture(FEEDBACK_PROMPT_EVENTS.shown)
  }
